import { BoMItemRow } from 'model/Project/BoMItemRow'
import { MaterialKeywordsFilter } from 'store/Project/ProjectTypes'
import { showPartTypeBasedOnMaterials } from './showPartTypeBasedOnMaterials'

export function applyMaterialFilter(
  filter: MaterialKeywordsFilter,
  row: BoMItemRow
): boolean {
  let materialFilterAppliedShowItem = false

  switch (row.type) {
    case 'Row': {
      materialFilterAppliedShowItem = showPartTypeBasedOnMaterials(
        row.materialSummary,
        filter
      )
    }
  }

  return materialFilterAppliedShowItem
}
